import { render, staticRenderFns } from "./followUpReviewTable.vue?vue&type=template&id=5d88e334"
import script from "./followUpReviewTable.vue?vue&type=script&lang=js"
export * from "./followUpReviewTable.vue?vue&type=script&lang=js"
import style0 from "./followUpReviewTable.vue?vue&type=style&index=0&id=5d88e334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports